import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section`
    display: block;
    margin: 0 calc(${props => props.theme.spacing.xxSmall} + ${props => props.theme.spacing.medium});
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0;
        padding: 0 ${props => props.theme.spacing.large};
    }
`
export const Container = styled.div`
    display: ${props => props.theme.style.display.flex};
    overflow: auto;
    ::-webkit-scrollbar {
        width: 0;
    }
    scrollbar-width: none;
    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        overflow: visible;
    }
`
export const TextWrapper = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-wrap: ${props => props.theme.style.flexWrap.wrap};
    flex-basis: ${props => props.theme.layout.fill};
    margin: 0 auto;
`

export const Text = styled.h2`
    margin: 1.5rem 0 1rem;
    font-size: ${({ theme }) => theme.typography.font.size.large};
    font-weight: 700;
    font-family: ${({ theme }) => theme.typography.font.family.yummoVerdana};
    line-height: 1.75rem;
    letter-spacing: -0.35px;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        line-height: 2.625rem;
        font-size: 2.25rem;
        letter-spacing: -1px;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 3.75rem 0 1.5rem;
    }
`

export const MenuWrapper = styled.div`
    border: ${props => props.theme.typography.border.width.xxxThin}
        ${props => props.theme.typography.border.style.solid} ${props => props.theme.colors.tfwBlackOpacity10};
    border-radius: ${props => props.theme.typography.border.radius.xLarge};
    min-width: 9.75rem;
    margin-right: ${props => props.theme.spacing.xSmall};
    padding: ${props => props.theme.spacing.medium} 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-width: 10.5rem;
        margin-right: ${props => props.theme.spacing.medium};
        padding: ${props => props.theme.spacing.large} 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        min-width: 12.05rem;
        margin-right: ${props => props.theme.spacing.large};
        padding-bottom: ${props => props.theme.spacing.large};
    }
`

export const MenuContainer = styled.a`
    text-align: ${props => props.theme.style.textAlign.left};
    text-decoration: none;
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    align-items: ${props => props.theme.style.alignItems.baseline};
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-style: normal;
    font-weight: 400;
    color: ${props => props.theme.colors.tfwBlack87};
    cursor: pointer;
`

export const IconBox = styled.div`
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 9.375rem 9.375rem;
    margin: 0 ${props => props.theme.spacing.medium} ${props => props.theme.spacing.xxSmall};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 0 ${props => props.theme.spacing.large} ${props => props.theme.spacing.small};
    }
`

export const TitleSpan = styled.span`
    width: 75%;
    white-space: nowrap;
    display: ${props => props.theme.style.display.block};
    font-weight: ${props => props.theme.typography.font.lato.weight.bold};
    font-size: ${props => props.theme.typography.font.size.small};
    font-family: ${props => props.theme.typography.font.family.lato};
    line-height: 1.5rem;
    margin: 0 ${props => props.theme.spacing.medium};
    overflow: hidden;
    text-overflow: ellipsis;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.medium};
        margin: 0 ${props => props.theme.spacing.large};
    }
`

export const SubtitleSpan = styled.span`
    font-family: ${props => props.theme.typography.font.family.lato};
    display: ${props => props.theme.style.display.block};
    font-weight: ${props => props.theme.typography.font.weight.normal};
    font-size: ${props => props.theme.typography.font.size.xSmall};
    line-height: 1rem;
    letter-spacing: 0.0125rem;
    color: ${props => props.theme.colors.tfwBlackOpacity50};
    margin-left: ${props => props.theme.spacing.medium};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.small};
        margin-left: ${props => props.theme.spacing.large};
        line-height: 1.5rem;
    }
`
